<template>
  <component
    :is="component"
    :type="type"
    :class="className"
    v-bind="bindProperties"
    @click="onClick"
    :data-event-category="eventCategory">
    <span
      v-if="copy"
      v-html="copy" />
    <slot v-else />
  </component>
</template>

<script>
import events from "@/events";

export default {
  name: "Button",
  props: {
    href: { type: String, default: null },
    copy: { type: String, default: "" },
    eventCategory: { type: String, default: "body-20200305-cta" },
    eventName: { type: String, default: null },
    isBlock: { type: Boolean, default: false },
    isCta: { type: Boolean, default: false },
    data: { type: Object, default: () => {} },
    modifiers: { type: Array, default: () => [] },
    openSignup: { type: Boolean, default: false },
    openLogin: { type: Boolean, default: false },
    useRouter: { type: Boolean, default: false },
    customClass: { type: String, default: null },
    type: { type: String, default: "submit" },
    reClickable: { type: Boolean, default: true }
  },
  data () {
    return {
      clicks: 0
    };
  },
  computed: {
    className() {
      const blockName = "button";
      let modifiers = this.modifiers;

      if (this.isBlock || this.isCta) {
        modifiers.push("block");
      }

      modifiers = modifiers.reduce((o, v) => {
        o[`${blockName}--${v}`] = true;
        return o;
      }, {});

      const custom = this.customClass ? { [this.customClass]: true } : {};

      return {
        [blockName]: true,
        ...modifiers,
        ...custom,
        "js-open-signup-popup": this.openSignup,
        "js-open-login-popup": this.openLogin,
        "button--inactive": !this.isClickable
      };
    },
    dataAttributes() {
      if (!this.data) {
        return {};
      }
      return Object.entries(this.data).reduce((object, value) => {
        object[`data-${value[0]}`] = value[1];
        return object;
      }, {});
    },
    linkObject() {
      return { href: this.href };
    },
    bindProperties() {
      return {
        ...this.linkObject,
        ...this.dataAttributes
      };
    },
    component() {
      if (this.href) {
        return "a";
      }
      return "button";
    },
    isClickable() {
      return this.reClickable || this.clicks === 0;
    }
  },
  methods: {
    onClick(e) {
      // We cannot relay on disabling the button instead, because that will cause HTML5 form validations
      // to not run, and then the user might not have any feedback on what is going on.
      if (!this.isClickable) {
        return;
      }

      if (this.eventName) {
        events.track(this.eventCategory, "1-click", this.eventName);
      } else {
        events.track(this.eventCategory, "1-click");
      }

      this.$emit("click", e);

      if (this.useRouter && this.$router) {
        this.$router.push(this.href);
        e.preventDefault();
      }

      this.clicks += 1;
    },
    resetClickCounter() {
      this.clicks = 0;
    }
  }
};
</script>
